export const GET_GOOGLE_TRANSLATE_TEXT = 'GET_GOOGLE_TRANSLATE_TEXT';
